import { render } from "./SectionAbout.vue?vue&type=template&id=6fd38ccb&scoped=true"
import script from "./SectionAbout.vue?vue&type=script&lang=js"
export * from "./SectionAbout.vue?vue&type=script&lang=js"

import "./SectionAbout.vue?vue&type=style&index=0&id=6fd38ccb&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6fd38ccb"

export default script